import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function Layout() {
  return (
    <div className="min-h-screen bg-pageBg text-slate-900 transition-colors duration-300 dark:bg-slate-950 dark:text-slate-100">
      <Sidebar />

      <div className="ml-64 flex min-h-screen min-w-0 flex-col overflow-hidden">
        <Topbar />

        <main className="flex-1 bg-pageBg p-6 dark:bg-slate-950">
          <Outlet />
        </main>
      </div>
    </div>
  );
}